/*
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-17 13:53:01
 * @LastEditTime: 2020-12-06 14:56:40
 * @FilePath: \ensurance-front\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './utils/permission.js'
import ElementUI from 'element-ui'
// import Cookies from 'js-cookie'
import store from './store/index'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/style-reset.scss'
import './styles/style-common.scss'
import moment from 'moment'
import Distpicker from 'v-distpicker'
Vue.component('v-distpicker', Distpicker)
Vue.use(ElementUI)
// Vue.prototype.$cookies = Cookies
Vue.config.productionTip = false

moment.locale('zh-cn')
Vue.prototype.$moment = moment

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created: function() {
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store'))
        )
      )
    }

    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js